import * as actionTypes from "./constants";
import countrycodes from "../../screens/Common/DropdownList/countryList";

const initialState = {
  processing: false,
  error: false,
  mailSent: false,

  autogenerateStatus: true,
  selectedValue: 0,
  collectionDataList: [],
  valveControlList: [],
  totalPaidCount: 0,
  totalUnpaidCount: 0,
  totalBillAmount: 0,
  aptDetails: [],
};

export default function ApartmentReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_APARTMENTDATA_INIT_ACTION:
      return {
        ...state,
        apartmentList: [],
        loading: true,
      };
    case actionTypes.FETCH_APARTMENTDATA_SUCCESS_ACTION:
      return {
        ...state,
        apartmentList: action.payload.response_data.apts,
        loading: false,
      };
    case actionTypes.FETCH_APARTMENTDATA_FAIL_ACTION:
      return {
        ...state,
        apartmentList: [],
        loading: false,
      };
    case actionTypes.FETCH_APARTMENTAPPUSERDATA_INIT_ACTION:
      return {
        ...state,
        appUserList: [],
        appuserloading: true,
      };
    case actionTypes.FETCH_APARTMENTAPPUSERDATA_SUCCESS_ACTION:
      return {
        ...state,
        appUserList: action.payload.response_data.users,
        appuserloading: false,
      };
    case actionTypes.FETCH_APARTMENTAPPUSERDATA_FAIL_ACTION:
      return {
        ...state,
        appUserList: [],
        appuserloading: false,
      };
    case actionTypes.DELETE_APARTMENTAPPUSERDATA_SUCCESS_ACTION:
      return {
        ...state,
        appUserList: state.appUserList.filter(
          (item) => item.rowId !== action.payload.rowId
        ),
      };
    case actionTypes.GENERATE_COLLECTION_SUCCESS_ACTION:
      return {
        ...state,
        mailSent: action.payload.status === "success" ? true : false,
      };

    case actionTypes.FETCH_COLLECTIONISMAILSENT_SUCCESS_ACTION:
      let temp = action.payload.response_data.status == 1 ? true : false;
      return {
        ...state,
        isMailSentList: action.payload.response_data,
        mailSent: temp,
      };
    case actionTypes.FETCH_COLLECTIONISMAILSENT_FAIL_ACTION:
      return {
        ...state,
        mailSent: false,
        isMailSentList: {},
      };
    case actionTypes.FETCH_COLLECTION_REPORT_AUTO_GENERATE_SUCCESS_ACTION:
      return {
        ...state,
        autogenerateStatus:
          action?.payload?.response_data?.autoGenerateStatus == 1
            ? true
            : false,
        selectedValue: 0,
      };
    case actionTypes.FETCH_COLLECTION_REPORT_AUTO_GENERATE_FAIL_ACTION:
      return {
        ...state,
        autogenerateStatus: true,
        selectedValue: 0,
      };
    case actionTypes.FETCH_REGENERATE_SUCCESS_ACTION:
      return {
        ...state,
        getBillCycleDetailList: action.payload.response_data,
      };
    case actionTypes.FETCH_REGENERATE_FAIL_ACTION:
      return {
        ...state,
        getBillCycleDetailList: {},
      };
    case actionTypes.FETCH_COLLECTIONDATA_INIT_ACTION:
      return {
        ...state,
        collectionDataList: [],
        collectionloading: true,
      };
    case actionTypes.FETCH_COLLECTIONDATA_SUCCESS_ACTION:
      // const collectionData = action.payload.response_Data.data.map(
      //   (item, i) => ({ ...item, id: i })
      // );

      const rawData = action.payload.response_data;

      // [
      //   {
      //     "A G01": {
      //       cyclestart: "2025-10-01",
      //       consumption: 35870.0,
      //       billamount: 3640.7,
      //       paidamount: 0.0,
      //       adjustment: 0.0,
      //       payment_mode: null,
      //     },
      //   },
      //   {
      //     "A 101": {
      //       cyclestart: "2025-10-01",
      //       consumption: 11186.0,
      //       billamount: 1419.14,
      //       paidamount: 0.0,
      //       adjustment: 0.0,
      //       payment_mode: null,
      //     },
      //   },
      //   {
      //     "A G01": {
      //       cyclestart: "2025-09-01",
      //       consumption: 27103.87,
      //       billamount: 2851.7483,
      //       adjustmen: 200.0,
      //       payment_mode: "creditCard",
      //     },
      //   },
      //   {
      //     "B 418": {
      //       cyclestart: "2025-09-01",
      //       consumption: 10864.76,
      //       billamount: 1190.2284,
      //       paidamount: 2651.7483,
      //       adjustment: 0.0,
      //       payment_mode: "UPI",
      //     },
      //   },
      // ];

      // const collectionData = Object.entries(rawData).map(
      //   ([aptNo, details], i) => {
      //     const isPaid =
      //       // Number(details.billamount || 0) === Number(details.paidamount || 0);
      //       Number(details.paidamount || 0) >= Number(details.billamount || 0);

      //     return {
      //       id: i,
      //       aptNo,
      //       ...details,
      //       status: isPaid ? "Paid" : "Unpaid",
      //     };
      //   }
      // );

      // const groupedByCycle = collectionData.reduce((acc, curr) => {
      //   const { cyclestart } = curr;
      //   if (!acc[cyclestart]) acc[cyclestart] = [];
      //   acc[cyclestart].push(curr);
      //   return acc;
      // }, {});
      const collectionData = rawData.flatMap((item, i) => {
        const [aptNo, details] = Object.entries(item)[0]; // extract key and value
        const isPaid =
          Number(details.paidamount || 0) >= Number(details.billamount || 0);

        return [
          {
            id: i,
            aptNo,
            ...details,
            status: isPaid ? "Paid" : "Unpaid",
          },
        ];
      });

      const groupedByCycle = collectionData.reduce((acc, curr) => {
        const { cyclestart } = curr;
        if (!acc[cyclestart]) acc[cyclestart] = [];
        acc[cyclestart].push(curr);
        return acc;
      }, {});

      let transformedData = Object.keys(groupedByCycle).map((cycle) => {
        const items = groupedByCycle[cycle];
        const totalAmount = items.reduce(
          (sum, item) => sum + (item.billamount || 0),
          0
        );
        const collectedAmount = items.reduce(
          (sum, item) => sum + (item.paidamount || 0),
          0
        );
        return {
          cyclestart: cycle,
          totalAmount,
          collectedAmount,
          data: items,
        };
      });

      transformedData = transformedData.sort(
        (a, b) =>
          new Date(b.cyclestart).getTime() - new Date(a.cyclestart).getTime()
      );

      const tempTotalCollectedAmount = transformedData[0]?.collectedAmount || 0;
      localStorage.setItem("TotalCollectedAmount", tempTotalCollectedAmount);

      const paidCount =
        transformedData[0]?.data?.filter((e) => e.status === "Paid")?.length ||
        0;
      const unpaidCount =
        transformedData[0]?.data?.filter((e) => e.status === "Unpaid")
          ?.length || 0;

      const totalAmount = Number(transformedData[0]?.totalAmount) || 0;
      const collectedAmount = Number(transformedData[0]?.collectedAmount) || 0;
      const balanceAmount = totalAmount - collectedAmount;

      return {
        ...state,
        collectionDataList: transformedData,
        collectionloading: false,
        totalPaidCount: paidCount,
        totalUnpaidCount: unpaidCount,
        totalBillAmount: totalAmount,
        totalCollectedAmount: collectedAmount,
        balanceAmount: balanceAmount,
      };

    case actionTypes.FETCH_COLLECTIONDATA_FAIL_ACTION:
      localStorage.setItem("TotalCollectedAmount", 0);
      return {
        ...state,
        collectionDataList: [],
        collectionloading: false,
        totalPaidCount: 0,
        totalUnpaidCount: 0,
        totalBillAmount: 0,
        balanceAmount: 0,
      };
    case actionTypes.FETCH_COLLECTION_APARTMENTS_INIT_ACTION:
      return {
        ...state,
      };
    case actionTypes.FETCH_COLLECTION_APARTMENTS_SUCCESS_ACTION:
      return {
        ...state,
        collectionApartmentList: action.payload.response_data,
      };
    case actionTypes.FETCH_COLLECTION_APARTMENTS_FAIL_ACTION:
      return {
        ...state,
        collectionApartmentList: {},
      };
    case actionTypes.FETCH_DOWNLOAD_WATER_CARD_SUCCESS_ACTION:
      return {
        ...state,
        downloadWaterCardList: action.payload.response_data.bills,
      };
    case actionTypes.FETCH_DOWNLOAD_WATER_CARD_FAIL_ACTION:
      return {
        ...state,
        downloadWaterCardList: [],
      };
    case actionTypes.CONSOLIDATED_BILL_VIEW_INIT_ACTION:
      return {
        ...state,
        consolidatedbillviewlist: [],
      };
    case actionTypes.CONSOLIDATED_BILL_VIEW_SUCCESS_ACTION:
      return {
        ...state,
        consolidatedbillviewlist:
          action.payload?.map((item) => ({
            payment_id: item.payment_id,
            property: item.property,
            unit: item.unit,
            paidAmount: item.paid_amount,
            paymentMode: item.payment_mode,
            paymentDate: new Date(item.payment_epoch * 1000)
              .toISOString()
              .split("T")[0],
          })) || [],
        // consolidatedbillviewlist: data,
      };
    case actionTypes.CONSOLIDATED_BILL_VIEW_FAIL_ACTION:
      return {
        ...state,
        consolidatedbillviewlist: [],
      };
    case actionTypes.FETCH_PENDING_BILLS_SUCCESS_ACTION:
      return {
        ...state,
        pendingBillsList: action.payload.response_data.pendingbills,
      };
    case actionTypes.FETCH_PENDING_BILLS_FAIL_ACTION:
      return {
        ...state,
        pendingBillsList: [],
      };
    case actionTypes.FETCH_METER_WISE_CONSUMPTION_INIT_ACTION:
      return {
        ...state,
        consumptionloading: true,
        consumptionDataList: [],
      };
    case actionTypes.FETCH_METER_WISE_CONSUMPTION_SUCCESS_ACTION:
      return {
        ...state,
        consumptionDataList: action.payload.response_data,
        consumptionCount: action.payload.length,
        consumptionloading: false,
      };
    case actionTypes.FETCH_METER_WISE_CONSUMPTION_FAIL_ACTION:
      return {
        ...state,
        consumptionloading: false,
        consumptionDataList: [],
      };

    // ***************************valve Control************************

    case actionTypes.FETCH_VALVE_CONTROL_DATA_INIT_ACTION:
      return {
        ...state,
      };
    case actionTypes.FETCH_VALVE_CONTROL_DATA_SUCCESS_ACTION:
      return {
        ...state,
        valveControlList: action.payload.response_data.rows,
      };
    case actionTypes.FETCH_VALVE_CONTROL_DATA_FAIL_ACTION:
      return {
        ...state,
        valveControlList: [],
      };
    case actionTypes.FETCH_VIEW_BILL_COMPACT_INIT_ACTION:
      return {
        ...state,
        GetAptBillCompact: {},
      };
    case actionTypes.FETCH_VIEW_BILL_COMPACT_SUCCESS_ACTION:
      return {
        ...state,
        GetAptBillCompact: action.payload.response_data,
      };
    case actionTypes.FETCH_TEMPLATE_SUCCESS_ACTION:
      return {
        ...state,
        TemplateId: action.payload.response_data.templateid,
      };
    case actionTypes.FETCH_TEMPLATE_FAIL_ACTION:
      return {
        ...state,
        TemplateId: "",
      };
    case actionTypes.FETCH_VALVE_HISTORY_INIT_ACTION:
      return {
        ...state,
        valvehistoryList: [],
        loadinghistory: true,
      };
    case actionTypes.FETCH_VALVE_HISTORY_SUCCESS_ACTION:
      return {
        ...state,
        valvehistoryList: action.payload.response_data.valvehistory,
        loadinghistory: false,
      };
    case actionTypes.FETCH_VALVE_HISTORY_FAIL_ACTION:
      return {
        ...state,
        valvehistoryList: [],
        loadinghistory: false,
      };
    case actionTypes.FETCH_INTERIM_BILLS_SUCCESS_ACTION:
      return {
        ...state,
        interimBillDetails: action.payload.response_data,
        loadingBill: false,
      };
    case actionTypes.FETCH_INTERIM_BILLS_INIT_ACTION:
      return {
        ...state,
        interimBillDetails: {},
        loadingBill: true,
      };
    case actionTypes.FETCH_INTERIM_BILLS_FAIL_ACTION:
      return {
        ...state,
        interimBillDetails: {},
        loadingBill: false,
      };
    case actionTypes.ADD_GENERATE_WATERCARD_INIT_ACTION:
      return {
        ...state,
        loadingGeneration: true,
      };
    case actionTypes.ADD_GENERATE_WATERCARD_SUCCESS_ACTION:
      return {
        ...state,
        loadingGeneration: false,
      };
    case actionTypes.ADD_GENERATE_WATERCARD_FAIL_ACTION:
      return {
        ...state,
        loadingGeneration: false,
      };
    case actionTypes.ADD_REGWATERCARD_INIT_ACTION:
      return {
        ...state,
        loadingRegeneration: true,
      };
    case actionTypes.ADD_REGWATERCARD_SUCCESS_ACTION:
      return {
        ...state,
        loadingRegeneration: false,
      };
    case actionTypes.ADD_REGWATERCARD_FAIL_ACTION:
      return {
        ...state,
        loadingRegeneration: false,
      };
    case actionTypes.FETCH_APARTMENTBYID_INIT_ACTION:
      return {
        ...state,
        aptDetails: [],
      };
    case actionTypes.FETCH_APARTMENTBYID_SUCCESS_ACTION:
      let owner = null;
      let lastOwner = null;
      let tenant = null;
      let lastTenant = null;
      const unitName = action.payload.data[0].unit;
      const residentsArr = action.payload.data?.map((item) => ({
        ...item,
        id: Math.floor(Math.random() * 1000000),
      }));

      for (let res of action.payload.data) {
        if (res.residentType === "Owner") {
          lastOwner = res;
          if (res.residentName && res.residentName.trim()) {
            owner = res;
          }
        } else if (res.residentType === "Tenant") {
          lastTenant = res;
          if (res.residentName && res.residentName.trim()) {
            tenant = res;
          }
        }
      }

      // Fallbacks
      owner = owner || lastOwner;
      tenant = tenant || lastTenant;

      const resident = tenant || owner;
      const match = countrycodes.find((code) =>
        owner?.phone.startsWith(code.cc)
      );
      const match1 = countrycodes.find((code) =>
        resident?.phone.startsWith(code.cc)
      );

      const apartmentData = {
        aptId: unitName,
        aptNo: unitName,
        towerName: "All",

        // Owner
        ownerName: owner?.residentName || "",
        // ownerPhone: owner?.phone || "",
        ownerPhone: owner?.phone
          ? match.cc + "-" + owner?.phone.slice(match.cc.length)
          : "",
        ownerEmail: owner?.email || "",
        isappuserowner:
          owner?.appUser === "1" || owner?.appUser === 1 ? true : false,

        // Resident (owner if tenant missing)
        residentName: resident?.residentName || "",
        // residentPhone: resident?.phone || "",
        residentPhone: resident?.phone
          ? match1.cc + "-" + resident?.phone.slice(match1.cc.length)
          : "",
        residentEmail: resident?.email || "",
        isappuserresident:
          resident?.appUser === "1" || resident?.appUser === 1 ? true : false,
        comment: "",
      };

      let appUserdata = [];

      for (const resident of residentsArr) {
        const isAppUser = resident.appUser === "1" || resident.appUser === 1;

        const countryCode = countrycodes.find((code) =>
          resident.phone.startsWith(code.cc)
        );
        // const mobile = resident.phone.slice(-10);
        if (isAppUser) {
          appUserdata.push({
            // mobileNumber: resident.phone || "",
            mobileNumber: resident.phone.slice(countryCode.cc.length),
            mobileNo: resident.phone
              ? `91${resident.phone.replace(/^(\+91|91)?/, "")}`
              : "",
            isdCode: countryCode.cc,
            aptId: unitName,
            aptNumber: unitName,
            emailID: resident.email || "",
            member_name: resident.residentName || "",
            gcmRegistration: null,
            lastLoginTime: null,
            appVisitedCount: 0,
            appType: "0",
            apns: "",
            isOwner: resident.residentType === "Owner" ? "1" : "0",
            rowId: Math.floor(Math.random() * 1000000),
            id: resident.id,
          });
        }
      }

      return {
        ...state,
        aptDetails: apartmentData,
        appUserList: appUserdata,
        residentsArr: residentsArr,
      };
    case actionTypes.FETCH_APARTMENTBYID_FAIL_ACTION:
      return {
        ...state,
        aptDetails: [],
      };
    default:
      return {
        ...state,
      };
  }
}
